import { useState, useEffect } from 'react';
import { createBillingCustomerPortalSession } from '../../store/actions/payments';
import { useDispatch, useSelector } from 'react-redux';
import { CreditCardOutlined, LoadingOutlined } from '@ant-design/icons';
import { setCustomerPortalSession } from '../../store/slices/payments';
import { useAuth } from '@frontegg/react';
import { Button } from '../baseComponents';
import { analytics } from 'src/services';
import classNames from 'classnames';

export const StripeBillingCustomerPortal = ({
  name = 'Manage Billing',
  type = 'link',
  className,
}) => {
  const dispatch = useDispatch();
  const { customerPortalSession } = useSelector((state) => state.paymentsState);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuth();

  const onClick = () => {
    analytics.track('Clicked On Manage Billing', { email: user?.email });
    setIsLoading(true);
    dispatch(createBillingCustomerPortalSession());
  };

  useEffect(() => {
    if (customerPortalSession?.url) {
      analytics.track('Stripe Billing URL Opened In New Tab', {
        email: user?.email,
      });
      setIsLoading(false);
      const url = customerPortalSession.url;
      dispatch(setCustomerPortalSession(null));
      // Add setTimeout so that tab opens in Safari/iOS.
      setTimeout(() => {
        window.open(url, '_blank', 'noopener,noreferrer');
      }, 0);
    }
  }, [customerPortalSession, dispatch]);

  return (
    <div className="flex items-center">
      {type === 'link' ? (
        <div
          className={classNames('flex p-4 cursor-pointer', className)}
          onClick={onClick}
          style={{ opacity: isLoading ? 0.5 : 1 }}
        >
          <div className="text-sm flex items-center">
            {isLoading ? (
              <LoadingOutlined className="mr-2" spin />
            ) : (
              <CreditCardOutlined className="mr-2" />
            )}
            <span>{name}</span>
          </div>
        </div>
      ) : (
        <Button
          type={'button'}
          className={classNames(
            'rounded-xl flex items-center gap-2 cursor-pointer',
            className
          )}
          onClick={onClick}
          loading={isLoading}
        >
          <CreditCardOutlined className="mr-2" />
          <span>{name}</span>
        </Button>
      )}
    </div>
  );
};
